// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-dropdown .ats-filter .ant-tabs-nav
{
    width: 190px !important;
}
.resolve-conflict-table  td.ant-table-cell
{
  max-width:200px;
  min-width:200px;
  padding: 8px !important;
  text-align: center;
}
.resolve-conflict-table  th.ant-table-cell
{
  text-align: center;
  padding: 8px !important;
  font-weight: 600;
  color: #808697;
}
  
thead .uploaded-data
{
  border: 2px solid !important;
  border-color: #000 !important;
  text-align: center;
}
tbody .uploaded-data
{
  border-left: 2px solid !important;
  border-right: 2px solid !important;
  text-align: center;
}
tbody tr:last-child td.uploaded-data
{
  border-bottom: 2px solid !important;
}
.uploaded-data
{
  color:#000 !important;
}
.resolve-conflict-table .conflict-staus-action,.resolve-conflict-table .uploaded-data
{
  padding: 8px !important;
}
.resolve-conflict-table .conflict-staus-action button
{
  display: flex;
  margin: auto;
}

.overflow-hidden-tree .ant-tabs-content
{
  overflow: visible !important;
}
.tree-select-degree .ant-select-dropdown.ant-tree-select-dropdown.ant-select-dropdown-placement-bottomLeft 
{
  min-width:260px !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/ATS/style.css"],"names":[],"mappings":"AAAA;;IAEI,uBAAuB;AAC3B;AACA;;EAEE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;;EAEE,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;AACpB;AACA;;EAEE,mCAAmC;AACrC;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;AAC5B","sourcesContent":[".ant-dropdown .ats-filter .ant-tabs-nav\n{\n    width: 190px !important;\n}\n.resolve-conflict-table  td.ant-table-cell\n{\n  max-width:200px;\n  min-width:200px;\n  padding: 8px !important;\n  text-align: center;\n}\n.resolve-conflict-table  th.ant-table-cell\n{\n  text-align: center;\n  padding: 8px !important;\n  font-weight: 600;\n  color: #808697;\n}\n  \nthead .uploaded-data\n{\n  border: 2px solid !important;\n  border-color: #000 !important;\n  text-align: center;\n}\ntbody .uploaded-data\n{\n  border-left: 2px solid !important;\n  border-right: 2px solid !important;\n  text-align: center;\n}\ntbody tr:last-child td.uploaded-data\n{\n  border-bottom: 2px solid !important;\n}\n.uploaded-data\n{\n  color:#000 !important;\n}\n.resolve-conflict-table .conflict-staus-action,.resolve-conflict-table .uploaded-data\n{\n  padding: 8px !important;\n}\n.resolve-conflict-table .conflict-staus-action button\n{\n  display: flex;\n  margin: auto;\n}\n\n.overflow-hidden-tree .ant-tabs-content\n{\n  overflow: visible !important;\n}\n.tree-select-degree .ant-select-dropdown.ant-tree-select-dropdown.ant-select-dropdown-placement-bottomLeft \n{\n  min-width:260px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
